import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducers as globalErrorBoundaryReducers } from 'components/GlobalErrorBoundary';
import { reducers as toastReducers } from 'components/Toast';
import forgotPasswordReducer from './forgotPasswordReducer';

const reducersCombined = combineReducers({
    globalErrorBoundary: globalErrorBoundaryReducers,
    form: formReducer,
    forgotPassword: forgotPasswordReducer,
    ...toastReducers,
});

export default reducersCombined;
